module.exports = __webpack_public_path__ + "img/Seat Too Deep.5d050264.png";